import React from "react";
import { money2 } from "./payrollHelpers";

const COLS = [
  "Technician", "Pay Type", "Jobs", "Reg Hrs", "OT Hrs", "Salary", "Piece Rate",
  "Commission", "Bonus", "Adjustments", "Gross Pay", "Taxes", "Net Pay", "Exceptions", "Status",
];

export default function PayrollEmployeeTable({ rows, adjustmentsTotalByEmployee, taxByEmployee, onOpenDetail }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid="payroll-employee-table">
      <div className="overflow-x-auto">
        <table className="w-full text-[12.5px]">
          <thead className="bg-slate-50/60 border-b border-slate-200">
            <tr className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-500">
              {COLS.map((c, i) => (
                <th key={c} className={`px-2 py-2 ${i === 0 ? "text-left" : i === 1 ? "text-left" : i === COLS.length - 1 ? "text-left" : i === COLS.length - 2 ? "text-center" : "text-right"}`}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => {
              const adj = adjustmentsTotalByEmployee[r.tech.id] || 0;
              const tax = taxByEmployee[r.tech.id];
              const gross = r.total + adj;
              const net = gross - (tax?.currentDeductions || 0);
              return (
                <tr
                  key={r.tech.id} data-testid={`payroll-emp-row-${r.tech.id}`}
                  className="hover:bg-blue-50/50 cursor-pointer transition-colors"
                  onClick={() => onOpenDetail(r)}
                >
                  <td className="px-2 py-2 font-semibold text-slate-900">{r.tech.name}</td>
                  <td className="px-2 py-2"><span className="text-[10.5px] font-bold uppercase px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{r.pay.model}</span></td>
                  <td className="px-2 py-2 text-right">{r.jobsCount}</td>
                  <td className="px-2 py-2 text-right">{r.regularHours.toFixed(2)}</td>
                  <td className="px-2 py-2 text-right">{r.otHours > 0 ? r.otHours.toFixed(2) : <span className="text-slate-300">—</span>}</td>
                  <td className="px-2 py-2 text-right">{r.pay.model === "salary" ? money2(r.salaryPay) : <span className="text-slate-300">—</span>}</td>
                  <td className="px-2 py-2 text-right">{(r.pay.model === "flat" || r.pay.model === "piece_rate") ? money2(r.flatPay) : <span className="text-slate-300">—</span>}</td>
                  <td className="px-2 py-2 text-right">{r.commission > 0 ? money2(r.commission) : <span className="text-slate-300">—</span>}</td>
                  <td className="px-2 py-2 text-right">{r.bonus > 0 ? money2(r.bonus) : <span className="text-slate-300">—</span>}</td>
                  <td className={`px-2 py-2 text-right ${adj > 0 ? "text-emerald-700" : adj < 0 ? "text-rose-700" : "text-slate-300"}`}>{adj !== 0 ? money2(adj) : "—"}</td>
                  <td className="px-2 py-2 text-right font-semibold">{money2(gross)}</td>
                  <td className="px-2 py-2 text-right text-rose-600">{tax ? money2(tax.currentDeductions) : <span className="text-slate-300">—</span>}</td>
                  <td className="px-2 py-2 text-right font-bold text-emerald-700">{money2(net)}</td>
                  <td className="px-2 py-2 text-center text-slate-300" title="Exception detection is coming in a later phase">—</td>
                  <td className="px-2 py-2 text-slate-600">{r.tech.status || "—"}</td>
                </tr>
              );
            })}
            {rows.length === 0 && (
              <tr><td colSpan={COLS.length} className="px-2 py-8 text-center text-slate-400 italic">No employees with payroll data in this range.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
